var viewHistoryKey = 'view-history'

/**
 * 观看历史存储
 * @param {number} albumid 专辑id
 * @param {string} title 专辑名称
 * @param {number} playid 播放资源id(视频id、音频id)
 * @param {string} playTitle 播放资源名
 * @param {number} totalTime 总时长
 * @param {number} remainTime 剩余时长
 */
var beforWaitTime = 0
export function addHistory(albumid, title, img, playid, playTitle, totalTime, remainTime){
    if(totalTime&&beforWaitTime > remainTime) {
      beforWaitTime = remainTime
      return
    }
    if(!totalTime || remainTime - beforWaitTime >= 30) {
      let history = localStorage.getItem(viewHistoryKey)
      if(!history) {
        history = {}
      }else{
        history = JSON.parse(history)
      }
      if(history.hasOwnProperty(albumid)) {
        if(totalTime != 0 && !history[albumid].totalTime){
          history[albumid].totalTime = totalTime
        }
        if(history[albumid].playid != playid){
            history[albumid].playid = playid
            history[albumid].playTitle = playTitle
            history[albumid].totalTime = totalTime
        }
        history[albumid].remainTime = remainTime
        history[albumid].recordTime = new Date().getTime();
      }else{
        history[albumid] = {
            albumid: albumid, 
            title: title, 
            img: img,
            playid: playid, 
            playTitle: playTitle, 
            totalTime: totalTime, 
            remainTime: remainTime,
            recordTime: new Date().getTime()
        }
        overtake(history)
      }
      localStorage.setItem(viewHistoryKey, JSON.stringify(history))
      beforWaitTime = remainTime
    }
}
/**
 * 获取专辑id对应的专辑播放历史
 * @param {number} albumid 
 */
export function getHistoryForId(albumid){
    let history = localStorage.getItem(viewHistoryKey)
    if(!history){
      return false
    }
    history = JSON.parse(history)
    if(history.hasOwnProperty(albumid)){
      return history[albumid]
    }
    return false
}

export function readHistory(){
    let history = localStorage.getItem(viewHistoryKey)
    if(!history){
      return false
    }
    history = JSON.parse(history)
    // 排序
    let keys = Object.keys(history)
    keys.sort(function(a, b){
      return history[b].recordTime - history[a].recordTime
    })
    const today = []
    const yesterday = []
    const list = []
    const current = new Date(new Date().toLocaleDateString()).getTime()
    for(let key of keys){
      const day = (current-history[key].recordTime)/(60*60*24*1000)
      if(day < 0) {
        today.push(history[key])
      }else if(day <= 1){
        yesterday.push(history[key])
      }else{
        list.push(history[key])
      }
    }
    return {today: today, yeday: yesterday, other: list, all: keys}
}

export function clearHistory(){
    localStorage.setItem(viewHistoryKey, '')
}
/**
 * 删除单条播放记录
 * @param {number|Array} albumids
 */
export function deleteHistory(albumids){
    let history = localStorage.getItem(viewHistoryKey)
    if(!history){
      return
    }
    history = JSON.parse(history)
    if(albumids.constructor == Array){
      for(const albumid of albumids){
        if(history.hasOwnProperty(albumid)){
          delete history[albumid]
        }
      }
    }else{
      if(history.hasOwnProperty(albumids)){
        delete history[albumids]
      }
    }
    localStorage.setItem(viewHistoryKey, JSON.stringify(history))
}

function overtake(history){
    const length = Object.keys(history).length
    if(length <= 20){
      return
    }
    for(let i=0; i< length - 20; i++) {
      let lastKey = 0
      let ltiem = 0
      for(let key in history){
        if(ltiem < history[key].recordTime){
          lastKey = key
          ltiem = history[key].recordTime
        }
      }
      delete history[lastKey]
    }
}